// Move to src/types/documents.ts instead of src/sponsfi/types/documents.ts
export enum RetentionPolicy {
  ONE_YEAR = 'ONE_YEAR',
  THREE_YEARS = 'THREE_YEARS',
  FIVE_YEARS = 'FIVE_YEARS',
  SEVEN_YEARS = 'SEVEN_YEARS',
  TEN_YEARS = 'TEN_YEARS',
  PERMANENT = 'PERMANENT'
}

export enum SensitivityLevel {
  PUBLIC = 'PUBLIC',
  INTERNAL = 'INTERNAL',
  CONFIDENTIAL = 'CONFIDENTIAL',
  RESTRICTED = 'RESTRICTED'
}

export enum DocumentType {
  COMPLIANCE_DOCUMENT = 'COMPLIANCE_DOCUMENT',
  TAX_DOCUMENT = 'TAX_DOCUMENT',
  GRANT_DOCUMENT = 'GRANT_DOCUMENT',
  FINANCIAL_DOCUMENT = 'FINANCIAL_DOCUMENT',
  LEGAL_DOCUMENT = 'LEGAL_DOCUMENT',
  OTHER = 'OTHER'
}

export enum DocumentStatus {
  PENDING = 'PENDING',
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED',
  DELETED = 'DELETED',
  REJECTED = 'REJECTED',
  APPROVED = 'APPROVED',
  VALID = 'VALID',
  INVALID = 'INVALID'
}

export interface DocumentMetadata {
  id?: string;
  name: string;
  type: DocumentType;
  category: string;
  description?: string;
  createdAt?: Date;
  updatedAt?: Date;
  createdBy?: string;
  status: DocumentStatus;
  tags: string[];
  fiscalSponsorId: string;
  projectId?: string;
  requirementId?: string;
  version?: number;
  sensitivity: SensitivityLevel;
  retention: RetentionPolicy;
  customMetadata?: Record<string, any>;
}

export interface DocumentData {
  id: string;
  name: string;
  uploadDate: Date;
  status: DocumentStatus;
  downloadUrl: string;
  metadata: DocumentMetadata;
  url: string;
}

export interface DocumentUploadResponse {
  id: string;
  url: string;
  metadata: DocumentMetadata;
}

export interface DocumentSearchParams {
  type?: DocumentType;
  category?: string;
  status?: string;
  startDate?: Date;
  endDate?: Date;
  fiscalSponsorId?: string;
  projectId?: string;
  tags?: string[];
  metadata?: Record<string, any>;
  page?: number;
  limit?: number;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
}